/** Storage key constants — kept separate from LocalStorage to avoid CookieUtils ↔ LocalStorage cycles. */
export enum STORAGE_KEY {
  IS_ANONYMOUS = 'hzc_is_anonymous',
  TOP_LEFT_ITEMS = 'hzc_top_left_items',
  TOP_RIGHT_ITEMS = 'hzc_top_right_items',
  CITIES = 'hzc_cities',
  DISTRICTS = 'hzc_districts',
  SETTINGS_LAST_UPDATES = 'hzc_settings_last_updates',
  BASKET = 'hzc_basket',
  CHECKOUT_STATE = 'hzc_checkout_state',
  LAST_SELECTED_CITY = 'hzc_last_selected_city',
  LOCAL_USER = 'hzc_local_user',
  LOCAL_USER_NON_ENCRYPTED = 'hzcActiveUser',
  FOOTER = 'hzc_footer',
  FOOTER_LAST_UPDATE = 'hzc_footer_last_updated',
  LAST_ORDER_ID = 'hzc_last_order_id',
  LAST_PAYMENT_TYPE = 'hzc_last_payment_type',
  LOCAL_TOKEN = 'hzc_local_token',
  OTHER_CITY_ID = 'hzc_other_city_id',
  OTHER_CITY_TARGET_PATH = 'hzc_other_city_target_path',
  CAMPAIGN_NAME = 'hzc_campaign_name',
  CAMPAIGN_DATA = 'hzc_campaign_data',
  FAVORITES = 'hzc_favorites',
  ROUTE_CAMPAIGN_DISMISSED = 'hzc_rc_dismissed',
  DISTRICT_REMEDIATION = 'hzc_district_remediation',
}
